export const replaceQueryParam = (param: string, value: string, history: any) => {
  const searchParams = new URLSearchParams(history.location.search);
  searchParams.set(param, value);

  const updatedParams = [];
  for (const [key, val] of searchParams.entries()) {
    updatedParams.push(`${key}=${val}`);
  }

  const queryString = updatedParams.join('&');
  history.replace({
    search: `?${queryString}`,
  });
};
